import { render, staticRenderFns } from "./PurchaseInvoicesReportsTable.vue?vue&type=template&id=2d2ca285&"
import script from "./PurchaseInvoicesReportsTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports